/**
 * Utility function to check if eventCall is enabled in NAT traversal settings
 * @param {Object} natTraversalStr - The NAT traversal string from user.agents[0].nat_traversal
 * @returns {boolean} - Returns true if eventCall is enabled, false otherwise
 */
export const isEventCallEnabled = (natTraversalStr) => {
    if (!natTraversalStr) {
      return false;
    }
  
    try {
      
      const natTraversalJson = JSON.parse(natTraversalStr);
      const enableEventCall = natTraversalJson?.eventCall;
      
      
      if (!enableEventCall) {
        
        return false;
      } else {
        
        return true;
      }
    } catch (error) {
      console.log("[isEventCallEnabled]: error=", error.message);
      return false;
    }
  };
  
  /**
   * Checks if the user has eventCall enabled in their NAT traversal settings
   * @param {Object} user - The user object containing agents array
   * @returns {boolean} - Returns true if eventCall is enabled, false otherwise
   */
  export const isUserEventCallEnabled = (user) => {
    if (!user?.agents?.[0]?.nat_traversal) {
      return false;
    }
    
    return isEventCallEnabled(user.agents[0].nat_traversal);
  };
  